import { render, staticRenderFns } from "./PackagingCostTab.vue?vue&type=template&id=0acde2ab&scoped=true"
import script from "./PackagingCostTab.vue?vue&type=script&lang=js"
export * from "./PackagingCostTab.vue?vue&type=script&lang=js"
import style0 from "./PackagingCostTab.vue?vue&type=style&index=0&id=0acde2ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acde2ab",
  null
  
)

export default component.exports